import { render, staticRenderFns } from "./SourcingForm.vue?vue&type=template&id=a1f9998a&"
import script from "./SourcingForm.vue?vue&type=script&lang=js&"
export * from "./SourcingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports